import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Panel, Form, Input, Button, Field } from "../common/controls";
import theme from "../../styles/theme";

const AltAction = styled.p`
  margin-top: ${theme.space.md};
  text-align: center;
  font-size: ${theme.font.sm};
  color: ${theme.color.textFaint};

  a {
    color: ${theme.color.focus};
  }
`;

const Register = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const { register } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      showToast("Passwords do not match", "error");
      return;
    }
    try {
      await register(formData);
      navigate("/");
    } catch (error) {
      showToast(
        error.response?.data?.message || "Registration failed",
        "error"
      );
    }
  };

  return (
    <Panel>
      <h2>Register</h2>
      <Form onSubmit={handleSubmit}>
        <Field>
          Username
          <Input
            type="text"
            name="username"
            autoComplete="username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </Field>
        <Field>
          Email
          <Input
            type="email"
            name="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Field>
        <Field>
          Password
          <Input
            type="password"
            name="password"
            autoComplete="new-password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </Field>
        <Field>
          Confirm password
          <Input
            type="password"
            name="confirmPassword"
            autoComplete="new-password"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </Field>
        <Button type="submit">Register</Button>
      </Form>
      <AltAction>
        Already have an account? <Link to="/login">Login</Link>
      </AltAction>
    </Panel>
  );
};

export default Register;
